import styled from 'styled-components'

export const Container = styled.div`
  align-items: center;
  display: flex;
  justify-items: center;
`

export const Dot = styled.div<{
  isSelected: boolean
}>(({ isSelected, theme }) => ({
  backgroundColor: isSelected
    ? theme.color.deprecated.black.primary
    : theme.color.deprecated.gray.medium,
  borderRadius: '50%',
  height: theme.spacing(1),
  width: theme.spacing(1),
  marginLeft: theme.spacing(2),
}))
